module.exports = __webpack_public_path__ + "static/img/icon_pay.f58b8f4c.png";